module.exports = __webpack_public_path__ + "img/img_foot_L.e305a336.svg";